import React, { useEffect, createElement } from 'react';
import { ArrowRight } from 'lucide-react';
interface BreakoutVideoPageProps {
  videoId: string;
  title: string;
  videoNumber: number;
}
export function BreakoutVideoPage({
  videoId,
  title,
  videoNumber
}: BreakoutVideoPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
    const playerScript = document.createElement('script');
    playerScript.src = 'https://player.vimeo.com/api/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc]/20 selection:text-[#00f7fc]" data-id="element-707">
      {/* Top Bar */}
      <div className="w-full bg-[#00f7fc]/10 border-b border-[#00f7fc]/30" data-id="element-708">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-center gap-2 text-center" data-id="element-709">
          <span className="text-[#00f7fc] font-bold text-sm uppercase tracking-wider" data-id="element-710">
            Breakout Video {videoNumber} de 5
          </span>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 py-10 md:py-16" data-id="element-711">
        {/* Title */}
        <h1 className="text-2xl md:text-4xl font-black text-center leading-tight mb-10" data-id="element-712">
          {title}
        </h1>

        {/* Video */}
        <div className="relative mb-12" data-id="element-713">
          <div className="absolute -inset-1 bg-gradient-to-r from-[#00f7fc] via-[#00d7dc] to-[#00f7fc] opacity-40 blur-xl rounded-2xl" data-id="element-714"></div>
          <div className="relative bg-gray-900 border border-[#00f7fc]/50 rounded-2xl overflow-hidden shadow-2xl" data-id="element-715">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-716">
              <iframe src={`https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title={`Breakout Video ${videoNumber}`} data-id="element-717"></iframe>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-718">
          <a href="/book-call-strategy" className="inline-flex items-center gap-3 bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] hover:from-[#00d7dc] hover:to-[#00b8bc] text-black font-black uppercase tracking-wide rounded-full py-4 px-10 shadow-[0_0_30px_rgba(0,247,252,0.3)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-719">
            <span data-id="element-720">Volver a Confirmar Mi Llamada</span>
            <ArrowRight className="w-5 h-5" data-id="element-721" />
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-8 mt-12" data-id="element-722">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-723">
          <p className="text-[#00f7fc] font-bold text-lg mb-2" data-id="element-724">
            48HRSCASHMACHINE.COM
          </p>
          <p className="text-gray-400 text-xs" data-id="element-725">
            Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}